import React from 'react'

export default () => <span style={{ color: "#cc0a0a" }}>&nbsp;*</span>